<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        reviewerList: this.reviewerList,
        errMsg: this.errMsg,
      }"
      v-on:input="formData = $event"
      v-on:cancel="cancelHandler"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import ReviewExerciseForm from "../../../components/performance/reviewexercise/Form_StaffReviewer";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ReviewExerciseForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      id: this.$route.params.id, //id for review exercise details
      pageTitle: this.$t('pmreviewexercise.editappraisalrecordfor'),
      pageTitleValue: this.$route.params.item.staffcode + " - " + this.$route.params.item.staffname,

      formData: {
        id: this.$route.params.id,
        pmreviewexerciseid : this.$route.params.formData.pmreviewexerciseid,
        pmrankmapsetid : this.$route.params.formData.pmrankmapsetid,
        reviewcode: this.$route.params.formData.reviewcode,
        description: this.$route.params.formData.description,
        assessmentcode: this.$route.params.formData.assessmentcode,
        startdate: this.$route.params.formData.startdate,
        enddate: this.$route.params.formData.enddate,
        formtype: this.$route.params.formData.type,
        staffid: this.$route.params.item.staffid,
        staffname: this.$route.params.item.staffname,
        staffcode: this.$route.params.item.staffcode,
        staffcompany : this.$route.params.item.compnycode,
        score: this.$route.params.item.score,
        rank: this.$route.params.item.rank,
        initiated: this.$route.params.formData.initiated,
        ongoing: this.$route.params.formData.ongoing,
        completed: this.$route.params.formData.completed,
        totalRecords: this.$route.params.formData.totalRecords,
        method: this.$route.params.formData.method,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      reviewerList: [],

      errMsg: "",
      isErr: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

  },

  mounted() {
  },
};
</script>